import { render, staticRenderFns, recyclableRender, components } from "./workOrder_dca.vue?vue&type=template&id=12e7f448&scoped=true&"
var renderjs
import script from "./workOrder_dca.vue?vue&type=script&lang=js&"
export * from "./workOrder_dca.vue?vue&type=script&lang=js&"
import style0 from "./workOrder_dca.vue?vue&type=style&index=0&id=12e7f448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e7f448",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/workOrder_dca/workOrder_dca.vue"
export default component.exports